import { BaseResource } from '../base-resource';

export class BookingContact extends BaseResource {
    constructor() {
        super();
        this.type = 'contact';
    }
}
